import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function IntegrationLoader() {
  return (
    <>
      <Grid container spacing={3} mt={2}>
        {[1, 2, 3, 4, 5, 6].map((idx) => (
          <Grid key={`skeleton-int-card-${idx}`} size={{ xs: 12, sm: 6, md: 4 }}>
            <Box
              bgcolor='#fff'
              border='1px solid #ECECEC'
              borderRadius='10px'
              p={2}
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              minHeight={200}
            >
              {/* Logo + Free badge */}
              <Box display='flex' justifyContent='space-between' alignItems='center' mb={1}>
                <Skeleton variant='rectangular' width={80} height={28} />
                <Skeleton variant='rectangular' width={50} height={20} sx={{ borderRadius: '8px' }} />
              </Box>

              {/* Title */}
              <Skeleton variant='text' width={120} height={24} sx={{ mb: 1 }} />

              {/* Description */}
              <Skeleton variant='text' width='90%' height={18} />
              <Skeleton variant='text' width='95%' height={18} />
              <Skeleton variant='text' width='70%' height={18} sx={{ mb: 2 }} />

              {/* Price + Button */}
              <Box display='flex' justifyContent='space-between' alignItems='center' mt='auto'>
                <Skeleton variant='text' width={100} height={24} />
                <Skeleton variant='rectangular' width={120} height={36} sx={{ borderRadius: '8px' }} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
